
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Blank Lines`}</h1>
<p>{`Never leave more than two contiguous blank lines.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
import foo from 'foo';



function bar(arg) {
  return foo(arg + 3);
}

// Good
import foo from 'foo';


function bar(arg) {
  return foo(arg + 3);
}
`}</code></pre>
<p>{`Never have more than one blank line in a block of code.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo(arg) {
  const a = 1;


  return a + arg;
}

if (a < b) {
  const foo = 2;
  const bar = 4;


  return foo + bar;
}

class Person {
  name;

  
  constructor(name) {
    this.name = name;
  }
}

// Good
function foo(arg) {
  const a = 1;

  return a + arg;
}

if (a < b) {
  const foo = 2;
  const bar = 4;

  return foo + bar;
}

class Person {
  name;
  
  constructor(name) {
    this.name = name;
  }
}
`}</code></pre>
<p>{`Don't pad blocks with blank lines.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo(arg) {
  
  const a = 1;

  return a + arg;

}

if (a < b) {
  
  const foo = 2;
  const bar = 3;

  return foo + bar;

}

class Person {

  constructor(name) {
    this.name = name;
  }

  getName() {
    return this.name;
  }

}

// Good
function foo(arg) {
  const a = 1;
  
  return a + arg;
}

if (a < b) {
  const foo = 2;
  const bar = 3;

  return foo + bar;
}

class Person {
  constructor(name) {
    this.name = name;
  }

  getName() {
    return this.name;
  }
}
`}</code></pre>
<p>{`Leave a blank line between a block and the next statement.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo(arg) {
  if (arg > 0) {
    const b = 2;
    return arg + b;
  }
  return arg;
}

class Person {
  constructor(name) {
    this.name = name;
  }
  getName() {
    return this.name;
  }
}

// Good
function foo(arg) {
  if (arg > 0) {
    const b = 2;
    return arg + b;
  }

  return arg;
}

class Person {
  constructor(name) {
    this.name = name;
  }

  getName() {
    return this.name;
  }
}
`}</code></pre>
<p>{`Use two blank lines to separate conceptually different parts in a module.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
import foo from 'foo';

function bar() {
  return foo() + 2;
}

function baz() {
  return foo() + 3;
}

// Good
import foo from 'foo';


function bar() {
  return foo() + 2;
}


function baz() {
  return foo() + 3;
}
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;